import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../Graphic.js";
import { FeatureSetQueryInterceptor as r } from "../../arcade/featureset/support/FeatureSetQueryInterceptor.js";
import i from "../../core/Accessor.js";
import o from "../../core/Handles.js";
import s from "../../core/Logger.js";
import { isSome as n } from "../../core/maybe.js";
import { isAbortError as a, eachAlways as l } from "../../core/promiseUtils.js";
import { throttle as p } from "../../core/throttle.js";
import { init as c } from "../../core/watchUtils.js";
import { property as d } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { cast as u } from "../../core/accessorSupport/decorators/cast.js";
import { subclass as f } from "../../core/accessorSupport/decorators/subclass.js";
import h from "../../popup/content/TextContent.js";
import m from "./FeatureAttachments/FeatureAttachmentsViewModel.js";
import _ from "./FeatureContent/FeatureContentViewModel.js";
import y from "./FeatureExpression/FeatureExpressionViewModel.js";
import b from "./FeatureFields/FeatureFieldsViewModel.js";
import g from "./FeatureMedia/FeatureMediaViewModel.js";
import { createCompiledExpressions as I } from "./support/arcadeFeatureUtils.js";
import { preLayerQueryCallback as A, preRequestCallback as v, createfieldInfoMap as M, getAllFieldInfos as x, getSourceLayer as w, substituteFieldsInLinksAndAttributes as C, isExpressionField as F, isRelatedField as E, formatEditInfo as T, graphicCallback as V, queryUpdatedFeature as P, formatAttributes as j } from "./support/featureUtils.js";
import { queryLayerInfos as L, queryRelatedFeatures as R, setRelatedFeatures as O, getRelatedFieldInfo as S, createRelatedInfo as k, updateRelatedInfo as U } from "./support/relatedFeatureUtils.js";

var _N;

var q = 1,
    D = "content-view-models",
    Q = "esri.widgets.FeatureViewModel",
    B = s.getLogger(Q),
    G = {
  attachmentsContent: !0,
  customContent: !0,
  expressionContent: !0,
  fieldsContent: !0,
  mediaContent: !0,
  textContent: !0
};

var H = _N = /*#__PURE__*/function (_i) {
  _inherits(N, _i);

  var _super = _createSuper(N);

  function N(e) {
    var _this;

    _classCallCheck(this, N);

    _this = _super.call(this, e), _this._handles = new o(), _this._error = null, _this._featureAbortController = null, _this.graphicChangedThrottled = p(_this.graphicChanged, q, _assertThisInitialized(_this)), _this._expressionAttributes = null, _this._graphicExpressionAttributes = null, _this.abilities = _objectSpread({}, G), _this.content = null, _this.contentViewModels = [], _this.defaultPopupTemplateEnabled = !1, _this.formattedAttributes = null, _this.lastEditInfo = null, _this.relatedInfos = new Map(), _this.title = "", _this.view = null, _this._isAllowedContentType = function (e) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          t = _assertThisInitialize.abilities;

      return "attachments" === e.type && t.attachmentsContent || "custom" === e.type && t.customContent || "fields" === e.type && t.fieldsContent || "media" === e.type && t.mediaContent || "text" === e.type && t.textContent || "expression" === e.type && t.expressionContent;
    }, _this._handles.add(c(_assertThisInitialized(_this), ["graphic", "_effectivePopupTemplate", "abilities"], function () {
      return _this.graphicChangedThrottled();
    }));
    return _this;
  }

  _createClass(N, [{
    key: "destroy",
    value: function destroy() {
      this._clear(), this._cancelFeatureQuery(), this._error = null, this._handles.destroy(), this._handles = null, this.graphic = null, this._destroyContentViewModels(), this.relatedInfos.clear();
    }
  }, {
    key: "_effectivePopupTemplate",
    get: function get() {
      return n(this.graphic) ? this.graphic.getEffectivePopupTemplate(this.defaultPopupTemplateEnabled) : null;
    }
  }, {
    key: "_fieldInfoMap",
    get: function get() {
      return M(x(this._effectivePopupTemplate), this._sourceLayer);
    }
  }, {
    key: "_sourceLayer",
    get: function get() {
      return w(this.graphic);
    }
  }, {
    key: "castAbilities",
    value: function castAbilities(e) {
      return _objectSpread(_objectSpread({}, G), e);
    }
  }, {
    key: "state",
    get: function get() {
      return this.graphic ? this._error ? "error" : this.waitingForContent ? "loading" : "ready" : "disabled";
    }
  }, {
    key: "graphic",
    set: function set(e) {
      this._set("graphic", e ? e.clone() : null);
    }
  }, {
    key: "spatialReference",
    get: function get() {
      return this.get("view.spatialReference") || null;
    },
    set: function set(e) {
      void 0 !== e ? this._override("spatialReference", e) : this._clearOverride("spatialReference");
    }
  }, {
    key: "map",
    get: function get() {
      return this.get("view.map") || null;
    },
    set: function set(e) {
      void 0 !== e ? this._override("map", e) : this._clearOverride("map");
    }
  }, {
    key: "waitingForContent",
    get: function get() {
      return !!this._featureAbortController;
    }
  }, {
    key: "setActiveMedia",
    value: function setActiveMedia(e, t) {
      var r = this.contentViewModels[e];
      r instanceof g && r.setActiveMedia(t);
    }
  }, {
    key: "nextMedia",
    value: function nextMedia(e) {
      var t = this.contentViewModels[e];
      t instanceof g && t.next();
    }
  }, {
    key: "previousMedia",
    value: function previousMedia(e) {
      var t = this.contentViewModels[e];
      t instanceof g && t.previous();
    }
  }, {
    key: "_clear",
    value: function _clear() {
      this._set("title", ""), this._set("content", null), this._set("formattedAttributes", null);
    }
  }, {
    key: "graphicChanged",
    value: function () {
      var _graphicChanged = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var e, t;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._cancelFeatureQuery(), this._error = null, this._clear();
                e = this.graphic;

                if (e) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                t = new AbortController();
                this._featureAbortController = t;
                _context.prev = 6;
                _context.next = 9;
                return this._queryFeature({
                  signal: t.signal
                });

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);
                a(_context.t0) || (this._error = _context.t0, B.error("error", "The popupTemplate could not be displayed for this feature.", {
                  error: _context.t0,
                  graphic: e,
                  popupTemplate: this._effectivePopupTemplate
                }));

              case 14:
                this._featureAbortController === t && (this._featureAbortController = null);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 11]]);
      }));

      function graphicChanged() {
        return _graphicChanged.apply(this, arguments);
      }

      return graphicChanged;
    }()
  }, {
    key: "_cancelFeatureQuery",
    value: function _cancelFeatureQuery() {
      var e = this._featureAbortController;
      e && e.abort(), this._featureAbortController = null;
    }
  }, {
    key: "_compileContentElement",
    value: function _compileContentElement(e, t) {
      return "attachments" === e.type ? this._compileAttachments(e, t) : "custom" === e.type ? this._compileCustom(e, t) : "fields" === e.type ? this._compileFields(e, t) : "media" === e.type ? this._compileMedia(e, t) : "text" === e.type ? this._compileText(e, t) : "expression" === e.type ? this._compileExpression(e, t) : void 0;
    }
  }, {
    key: "_compileContent",
    value: function _compileContent(e) {
      var _this2 = this;

      if (this._destroyContentViewModels(), this.graphic) return Array.isArray(e) ? e.filter(this._isAllowedContentType).map(function (e, t) {
        return _this2._compileContentElement(e, t);
      }) : "string" == typeof e ? this._compileText(new h({
        text: e
      }), 0).text : e;
    }
  }, {
    key: "_destroyContentViewModels",
    value: function _destroyContentViewModels() {
      var e;
      null == (e = this._handles) || e.remove(D), this.contentViewModels.forEach(function (e) {
        return e && !e.destroyed && e.destroy();
      }), this._set("contentViewModels", []);
    }
  }, {
    key: "_setExpressionContentVM",
    value: function _setExpressionContentVM(e, t) {
      var r = this.formattedAttributes,
          i = e.contentElement,
          o = e.contentElementViewModel,
          s = null == i ? void 0 : i.type;
      o && s && ("fields" === s && (this._createFieldsFormattedAttributes({
        contentElement: i,
        contentElementIndex: t,
        formattedAttributes: r
      }), o.set(this._createFieldsVMParams(i, t))), "media" === s && (this._createMediaFormattedAttributes({
        contentElement: i,
        contentElementIndex: t,
        formattedAttributes: r
      }), o.set(this._createMediaVMParams(i, t))), "text" === s && o.set(this._createTextVMParams(i)));
    }
  }, {
    key: "_compileExpression",
    value: function _compileExpression(e, t) {
      var _this3 = this;

      var r = e.expressionInfo,
          i = this.graphic,
          o = this.map,
          s = this.spatialReference,
          n = this.view,
          a = new y({
        expressionInfo: r,
        graphic: i,
        interceptor: _N.interceptor,
        map: o,
        spatialReference: s,
        view: n
      });
      return this.contentViewModels[t] = a, this._handles.add(c(a, "contentElementViewModel", function () {
        return _this3._setExpressionContentVM(a, t);
      }), D), e;
    }
  }, {
    key: "_compileAttachments",
    value: function _compileAttachments(e, t) {
      var r = this.graphic,
          i = e.description,
          o = e.title;
      return this.contentViewModels[t] = new m(_objectSpread({
        graphic: r
      }, this._compileTitleAndDesc({
        title: o,
        description: i
      }))), e;
    }
  }, {
    key: "_compileCustom",
    value: function _compileCustom(e, t) {
      var r = this.graphic,
          i = e.creator,
          o = e.destroyer;
      return this.contentViewModels[t] = new _({
        graphic: r,
        creator: i,
        destroyer: o
      }), e;
    }
  }, {
    key: "_compileTitleAndDesc",
    value: function _compileTitleAndDesc(_ref) {
      var e = _ref.title,
          t = _ref.description;
      var r = this._fieldInfoMap,
          i = this._sourceLayer,
          o = this.graphic,
          s = this.formattedAttributes,
          n = this._expressionAttributes,
          a = o.attributes,
          l = s.global;
      return {
        title: C({
          attributes: a,
          fieldInfoMap: r,
          globalAttributes: l,
          expressionAttributes: n,
          layer: i,
          text: e
        }),
        description: C({
          attributes: a,
          fieldInfoMap: r,
          globalAttributes: l,
          expressionAttributes: n,
          layer: i,
          text: t
        })
      };
    }
  }, {
    key: "_createFieldsVMParams",
    value: function _createFieldsVMParams(e, t) {
      var r = this._effectivePopupTemplate,
          i = this.formattedAttributes,
          o = _objectSpread(_objectSpread({}, i.global), i.content[t]),
          s = (null == e ? void 0 : e.fieldInfos) || (null == r ? void 0 : r.fieldInfos),
          n = null == s ? void 0 : s.filter(function (_ref2) {
        var e = _ref2.fieldName;
        return F(e) || E(e) || o.hasOwnProperty(e);
      }),
          a = null == r ? void 0 : r.expressionInfos,
          l = e.description,
          p = e.title;

      return _objectSpread({
        attributes: o,
        expressionInfos: a,
        fieldInfos: n
      }, this._compileTitleAndDesc({
        title: p,
        description: l
      }));
    }
  }, {
    key: "_compileFields",
    value: function _compileFields(e, t) {
      var r = e.clone(),
          i = new b(this._createFieldsVMParams(e, t));
      return this.contentViewModels[t] = i, r.fieldInfos = i.formattedFieldInfos.slice(0), r;
    }
  }, {
    key: "_createMediaVMParams",
    value: function _createMediaVMParams(e, t) {
      var r = this.graphic,
          i = this._fieldInfoMap,
          o = this.formattedAttributes,
          s = this._effectivePopupTemplate,
          n = this.relatedInfos,
          a = this._sourceLayer,
          l = this._expressionAttributes,
          p = r.attributes,
          c = e.description,
          d = e.mediaInfos,
          u = e.title;
      return _objectSpread({
        activeMediaInfoIndex: e.activeMediaInfoIndex || 0,
        attributes: p,
        layer: a,
        fieldInfoMap: i,
        formattedAttributes: _objectSpread(_objectSpread({}, o.global), o.content[t]),
        expressionAttributes: l,
        mediaInfos: d,
        popupTemplate: s,
        relatedInfos: n
      }, this._compileTitleAndDesc({
        title: u,
        description: c
      }));
    }
  }, {
    key: "_compileMedia",
    value: function _compileMedia(e, t) {
      var r = e.clone(),
          i = new g(this._createMediaVMParams(e, t));
      return r.mediaInfos = i.formattedMediaInfos.slice(0), this.contentViewModels[t] = i, r;
    }
  }, {
    key: "_createTextVMParams",
    value: function _createTextVMParams(e) {
      var t = this.graphic,
          r = this._fieldInfoMap,
          i = this._sourceLayer,
          o = this._expressionAttributes;

      if (e && e.text) {
        var _s = t.attributes,
            _n = this.formattedAttributes.global;
        e.text = C({
          attributes: _s,
          fieldInfoMap: r,
          globalAttributes: _n,
          expressionAttributes: o,
          layer: i,
          text: e.text
        });
      }

      return {
        graphic: t,
        creator: e.text
      };
    }
  }, {
    key: "_compileText",
    value: function _compileText(e, t) {
      var r = e.clone();
      return this.contentViewModels[t] = new _(this._createTextVMParams(r)), r;
    }
  }, {
    key: "_compileLastEditInfo",
    value: function _compileLastEditInfo() {
      var e = this._effectivePopupTemplate,
          t = this._sourceLayer,
          r = this.graphic;
      if (!e) return;
      var i = e.lastEditInfoEnabled,
          o = null == t ? void 0 : t.editFieldsInfo;
      return i && o ? T(o, r.attributes) : void 0;
    }
  }, {
    key: "_compileTitle",
    value: function _compileTitle(e) {
      var t = this._fieldInfoMap,
          r = this._sourceLayer,
          i = this.graphic,
          o = this._expressionAttributes,
          s = i.attributes,
          n = this.formattedAttributes.global;
      return C({
        attributes: s,
        fieldInfoMap: t,
        globalAttributes: n,
        expressionAttributes: o,
        layer: r,
        text: e
      });
    }
  }, {
    key: "_getTitle",
    value: function () {
      var _getTitle2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var e, t, r;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e = this._effectivePopupTemplate, t = this.graphic, r = null == e ? void 0 : e.title;
                return _context2.abrupt("return", V(r, {
                  graphic: t
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _getTitle() {
        return _getTitle2.apply(this, arguments);
      }

      return _getTitle;
    }()
  }, {
    key: "_getContent",
    value: function () {
      var _getContent2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var e, t, r;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e = this._effectivePopupTemplate, t = this.graphic, r = null == e ? void 0 : e.content;
                return _context3.abrupt("return", V(r, {
                  graphic: t
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _getContent() {
        return _getContent2.apply(this, arguments);
      }

      return _getContent;
    }()
  }, {
    key: "_queryFeature",
    value: function () {
      var _queryFeature2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
        var t, r, i, o, s, n, a, _yield$l, p, c, _yield$l2, d;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = this._featureAbortController;
                r = this._sourceLayer;
                i = this.graphic;
                o = this._effectivePopupTemplate;
                s = this.spatialReference;
                n = this.map;
                a = this.view;
                _context4.next = 9;
                return l({
                  content: this._getContent(),
                  title: this._getTitle()
                });

              case 9:
                _yield$l = _context4.sent;
                p = _yield$l.content.value;
                c = _yield$l.title.value;

                if (!(t !== this._featureAbortController || !i)) {
                  _context4.next = 14;
                  break;
                }

                return _context4.abrupt("return");

              case 14:
                _context4.next = 16;
                return P({
                  graphic: i,
                  popupTemplate: o,
                  layer: r,
                  spatialReference: s
                }, e);

              case 16:
                _context4.next = 18;
                return l({
                  checkForRelatedFeatures: this._checkForRelatedFeatures(e),
                  expressionAttributes: I({
                    expressionInfos: null == o ? void 0 : o.expressionInfos,
                    spatialReference: s,
                    graphic: i,
                    map: n,
                    interceptor: _N.interceptor,
                    view: a
                  })
                });

              case 18:
                _yield$l2 = _context4.sent;
                d = _yield$l2.expressionAttributes.value;
                t === this._featureAbortController && i && (this._expressionAttributes = d, this._graphicExpressionAttributes = _objectSpread(_objectSpread({}, i.attributes), d), this._set("formattedAttributes", this._createFormattedAttributes(p)), this._set("title", this._compileTitle(c)), this._set("lastEditInfo", this._compileLastEditInfo() || null), this._set("content", this._compileContent(p) || null));

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _queryFeature(_x) {
        return _queryFeature2.apply(this, arguments);
      }

      return _queryFeature;
    }()
  }, {
    key: "_createMediaFormattedAttributes",
    value: function _createMediaFormattedAttributes(_ref3) {
      var e = _ref3.contentElement,
          t = _ref3.contentElementIndex,
          r = _ref3.formattedAttributes;
      var i = this._effectivePopupTemplate,
          o = this.graphic,
          s = this.relatedInfos,
          n = this._sourceLayer,
          a = this._fieldInfoMap,
          l = this._graphicExpressionAttributes;
      r.content[t] = j({
        fieldInfos: null == i ? void 0 : i.fieldInfos,
        graphic: o,
        attributes: _objectSpread(_objectSpread({}, l), e.attributes),
        layer: n,
        fieldInfoMap: a,
        relatedInfos: s
      });
    }
  }, {
    key: "_createFieldsFormattedAttributes",
    value: function _createFieldsFormattedAttributes(_ref4) {
      var e = _ref4.contentElement,
          t = _ref4.contentElementIndex,
          r = _ref4.formattedAttributes;

      if (e.fieldInfos) {
        var _i2 = this.graphic,
            _o = this.relatedInfos,
            _s2 = this._sourceLayer,
            _n2 = this._fieldInfoMap,
            _a = this._graphicExpressionAttributes;
        r.content[t] = j({
          fieldInfos: e.fieldInfos,
          graphic: _i2,
          attributes: _objectSpread(_objectSpread({}, _a), e.attributes),
          layer: _s2,
          fieldInfoMap: _n2,
          relatedInfos: _o
        });
      }
    }
  }, {
    key: "_createFormattedAttributes",
    value: function _createFormattedAttributes(e) {
      var _this4 = this;

      var t = this._effectivePopupTemplate,
          r = this.graphic,
          i = this.relatedInfos,
          o = this._sourceLayer,
          s = this._fieldInfoMap,
          n = this._graphicExpressionAttributes,
          a = null == t ? void 0 : t.fieldInfos,
          l = {
        global: j({
          fieldInfos: a,
          graphic: r,
          attributes: n,
          layer: o,
          fieldInfoMap: s,
          relatedInfos: i
        }),
        content: []
      };
      return Array.isArray(e) && e.forEach(function (e, t) {
        "fields" === e.type && _this4._createFieldsFormattedAttributes({
          contentElement: e,
          contentElementIndex: t,
          formattedAttributes: l
        }), "media" === e.type && _this4._createMediaFormattedAttributes({
          contentElement: e,
          contentElementIndex: t,
          formattedAttributes: l
        });
      }), l;
    }
  }, {
    key: "_checkForRelatedFeatures",
    value: function _checkForRelatedFeatures(e) {
      var t = this.graphic,
          r = this._effectivePopupTemplate;
      return this._queryRelatedInfos(t, x(r), e);
    }
  }, {
    key: "_queryRelatedInfos",
    value: function () {
      var _queryRelatedInfos2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, t, r) {
        var _this5 = this;

        var i, o, s, a, l, p;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                i = this.relatedInfos, o = this._sourceLayer;
                i.clear();

                if (!n(o.associatedLayer)) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 5;
                return o.associatedLayer.load(r);

              case 5:
                _context5.t0 = _context5.sent;
                _context5.next = 9;
                break;

              case 8:
                _context5.t0 = o;

              case 9:
                s = _context5.t0;

                if (s) {
                  _context5.next = 12;
                  break;
                }

                return _context5.abrupt("return");

              case 12:
                a = t.filter(function (e) {
                  return e && E(e.fieldName);
                });

                if (!(!a || !a.length)) {
                  _context5.next = 15;
                  break;
                }

                return _context5.abrupt("return");

              case 15:
                t.forEach(function (e) {
                  return _this5._configureRelatedInfo(e, s);
                });
                _context5.next = 18;
                return L({
                  relatedInfos: i,
                  layer: s
                }, r);

              case 18:
                l = _context5.sent;
                Object.keys(l).forEach(function (e) {
                  var t;
                  var r = i.get(e.toString()),
                      o = null == (t = l[e]) ? void 0 : t.value;
                  r && o && (r.layerInfo = o.data);
                });
                _context5.next = 22;
                return R({
                  graphic: e,
                  relatedInfos: i,
                  layer: s
                }, r);

              case 22:
                p = _context5.sent;
                Object.keys(p).forEach(function (e) {
                  var t;
                  O(null == (t = p[e]) ? void 0 : t.value, i.get(e.toString()));
                });

              case 24:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _queryRelatedInfos(_x2, _x3, _x4) {
        return _queryRelatedInfos2.apply(this, arguments);
      }

      return _queryRelatedInfos;
    }()
  }, {
    key: "_configureRelatedInfo",
    value: function _configureRelatedInfo(e, t) {
      var r = this.relatedInfos,
          i = S(e.fieldName);
      if (!i) return;
      var o = i.layerId,
          s = i.fieldName;
      if (!o) return;
      var n = r.get(o.toString()) || k(o, t);
      n && (U({
        relatedInfo: n,
        fieldName: s,
        fieldInfo: e
      }), this.relatedInfos.set(o, n));
    }
  }]);

  return N;
}(i);

H.interceptor = new r(A, v), e([d()], H.prototype, "_error", void 0), e([d()], H.prototype, "_featureAbortController", void 0), e([d({
  readOnly: !0
})], H.prototype, "_effectivePopupTemplate", null), e([d({
  readOnly: !0
})], H.prototype, "_fieldInfoMap", null), e([d({
  readOnly: !0
})], H.prototype, "_sourceLayer", null), e([d()], H.prototype, "abilities", void 0), e([u("abilities")], H.prototype, "castAbilities", null), e([d({
  readOnly: !0
})], H.prototype, "content", void 0), e([d({
  readOnly: !0
})], H.prototype, "contentViewModels", void 0), e([d({
  type: Boolean
})], H.prototype, "defaultPopupTemplateEnabled", void 0), e([d({
  readOnly: !0
})], H.prototype, "state", null), e([d({
  readOnly: !0
})], H.prototype, "formattedAttributes", void 0), e([d({
  type: t,
  value: null
})], H.prototype, "graphic", null), e([d({
  readOnly: !0
})], H.prototype, "lastEditInfo", void 0), e([d({
  readOnly: !0
})], H.prototype, "relatedInfos", void 0), e([d()], H.prototype, "spatialReference", null), e([d({
  readOnly: !0
})], H.prototype, "title", void 0), e([d()], H.prototype, "map", null), e([d({
  readOnly: !0
})], H.prototype, "waitingForContent", null), e([d()], H.prototype, "view", void 0), H = _N = e([f(Q)], H);
var z = H;
export { z as default };